import { T } from '../../../i18n/components/T.js'

interface Props {
  hasQuery: boolean
}

export const EmptyList = ({ hasQuery }: Props) => {
  if (hasQuery) {
    return (
      <div className="flex items-center justify-center">
        <T id="Generics.NoResults" defaultMessage="No results" />
      </div>
    )
  }

  return (
    <div className="flex items-center justify-center">
      <T id="Generics.NothingHereYet" defaultMessage="Nothing here yet." />
    </div>
  )
}
